import { Linking, Pressable, StyleSheet, Text, View } from "react-native";
import { useTranslation } from "react-i18next";
import { PRIVACY_URL, TERMS_URL } from "@heraion/shared";

import type { UiTheme } from "../theme";

// Privacy notice + Terms of use links, shared by the mobile and web Account
// cards. Underlined so the link is not signalled by colour alone.
export function LegalLinks({ theme }: { theme: UiTheme }) {
  const { t } = useTranslation();
  const { palette: p, spacing: s, typography: ty } = theme;
  const styles = StyleSheet.create({
    row: { flexDirection: "row", flexWrap: "wrap", columnGap: s.s5 },
    link: { minHeight: 44, justifyContent: "center" },
    text: {
      color: p.ink,
      fontSize: ty.sizes.base,
      textDecorationLine: "underline",
    },
  });
  const items = [
    { url: PRIVACY_URL, label: t("privacy.title") },
    { url: TERMS_URL, label: t("terms.title") },
  ];
  return (
    <View style={styles.row}>
      {items.map((it) => (
        <Pressable
          key={it.url}
          accessibilityRole="link"
          accessibilityHint={t("mobile.profile.legalLinkHint")}
          style={styles.link}
          onPress={() => void Linking.openURL(it.url)}
        >
          <Text style={styles.text}>{it.label}</Text>
        </Pressable>
      ))}
    </View>
  );
}
